// Actions for the "Requisitos Base"

import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  BaseRequirement,
  BaseRequirementsResult,
  OnAddBaseRequirementRequest,
  OnAddBaseRequirementResponse,
  OnCreateBaseRequirementRequest,
  OnUpdateBaseRequirementByIDRequest,
} from "../interfaces/base-requirements.types.ts";
import api from "../../api";
import { getExceptionMessage } from "../../exceptions/helpers/getExceptionMessage.ts";
import { baseRequirementExceptions } from "../../exceptions/default/baseRequirementExceptions.ts";

export const fetchAllBaseRequirements = createAsyncThunk(
  "base-requirements/fetchAllBaseRequirements",
  async (url: string, thunkAPI) => {
    try {
      const response = await api.get<BaseRequirementsResult>(url);
      return response.data;
    } catch (error: any) {
      const msg = getExceptionMessage(
        error.response.data?.code,
        baseRequirementExceptions.fetchAllBaseRequirements,
      );
      return thunkAPI.rejectWithValue(msg);
    }
  },
);

export const fetchBaseRequirementByID = createAsyncThunk(
  "base-requirements/fetchBaseRequirementByID",
  async (id: string, thunkAPI) => {
    try {
      const response = await api.get<BaseRequirement>(
        `/docvault/base-requirements/${id}/`,
      );
      return response.data;
    } catch (error: any) {
      const msg = getExceptionMessage(
        error.response.data?.code,
        baseRequirementExceptions.fetchBaseRequirementByID,
      );
      return thunkAPI.rejectWithValue(msg);
    }
  },
);

export const createBaseRequirement = createAsyncThunk(
  "base-requirements/createBaseRequirement",
  async ({ name, type }: OnCreateBaseRequirementRequest, thunkAPI) => {
    try {
      const response = await api.post<BaseRequirement>(
        `/docvault/base-requirements/`,
        { name, type },
      );
      return response.data;
    } catch (error: any) {
      const msg = getExceptionMessage(
        error.response.data?.code,
        baseRequirementExceptions.createBaseRequirement,
      );
      return thunkAPI.rejectWithValue(msg);
    }
  },
);

export const updateBaseRequirementByID = createAsyncThunk(
  "base-requirements/updateBaseRequirementByID",
  async ({ id, name, type }: OnUpdateBaseRequirementByIDRequest, thunkAPI) => {
    try {
      const response = await api.patch<BaseRequirement>(
        `/docvault/base-requirements/${id}/`,
        { name, type },
      );
      return response.data;
    } catch (error: any) {
      const msg = getExceptionMessage(
        error.response.data?.code,
        baseRequirementExceptions.updateBaseRequirementByID,
      );
      return thunkAPI.rejectWithValue(msg);
    }
  },
);

export const addBaseRequirement = createAsyncThunk(
  "base-requirements/addBaseRequirement",
  async (
    { subfolder_pk, base_requirement }: OnAddBaseRequirementRequest,
    thunkAPI,
  ) => {
    try {
      const response = await api.post<OnAddBaseRequirementResponse>(
        `/docvault/subfolders/${subfolder_pk}/requirements/`,
        { base_requirement },
      );
      return response.data;
    } catch (error: any) {
      const msg = getExceptionMessage(
        error.response.data?.code,
        baseRequirementExceptions.addBaseRequirement,
      );
      return thunkAPI.rejectWithValue(msg);
    }
  },
);
